import { useLocation } from 'react-router-dom';
import SEO from './SEO';
import { seoConfig } from '../seo/seoConfig';

export default function SEOHandler() {
	const location = useLocation();

	// Handle dynamic routes like /formations/agentic-ia/program
	const path = Object.keys(seoConfig).find((route) =>
		location.pathname.startsWith(route),
	);

	const seo = seoConfig[path] || seoConfig['/'];

	return (
		<SEO
			title={seo.title}
			description={seo.description}
			path={location.pathname}
		/>
	);
}
